import { GQLSessionNoteType } from '@upheal/graphql/definitions/schema.generated';

export const isAvailableSessionType = (
    sessionType: GQLSessionNoteType,
    availableSessionTypes: GQLSessionNoteType[] | undefined,
) => {
    if (!availableSessionTypes) {
        return true;
    }

    return availableSessionTypes.includes(sessionType);
};
